import { render, staticRenderFns } from "./GroupListChart.vue?vue&type=template&id=31448fad&scoped=true&"
import script from "./GroupListChart.vue?vue&type=script&lang=ts&"
export * from "./GroupListChart.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListChart.vue?vue&type=style&index=0&id=31448fad&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31448fad",
  null
  
)

export default component.exports